import { ReactEventHandler } from 'react'

export const callAllHandlers =
  <T extends ReactEventHandler>(...handlers: (T | undefined)[]) =>
  (event: Parameters<T>[0]): void => {
    handlers.forEach((handler) => handler?.(event))
  }
